import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import {PaqueteSeguros} from '../../_models/paquete-seguros';
import {PaqueteSegurosSeguros} from '../../_models/paquete-seguros-seguros';
import {PaqueteSegurosService} from '../../_services/paquete-seguros.service';
import {PaqueteSegurosSegurosService} from '../../_services/paquete-seguros-seguros.service';
import {PaqueteSegurosSegurosPlanes} from '../../_models/paquete-seguros-seguros-planes';
import {SeguroPlanService} from '../../_services/seguro-plan.service';
import {PaqueteSegurosSegurosPlanesService} from '../../_services/paquete-seguros-seguros-planes.service';

@Component( {
  selector: 'app-paquete-seguros-detalle',
  templateUrl: 'paquete-seguros-detalle.component.html'
} )

export class PaqueteSegurosDetalleComponent implements OnInit {

  paqSeguro: PaqueteSeguros;
  listaPaqSegSeg: PaqueteSegurosSeguros[] = [];
  carInformacionInicial = true;
  columnas: any[];
  paqSegSeg: PaqueteSegurosSeguros;


  constructor( private serSeguroPlan: SeguroPlanService,
               private serPaqSeguros: PaqueteSegurosSegurosService,
               private serPaqSegPlan: PaqueteSegurosSegurosPlanesService,
               private pagSeguroervicio: PaqueteSegurosService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location ) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nombreSeguto', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_PRODUCTO_SEGURO' ), sort: true },
      { field: 'simuladorCredito', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_SIMULADORCREDITO' ), sort: false },
      { field: 'planSeguro', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_PLAN' ), sort: true },
      { field: 'valorSeguro', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_VALOR_PLAN' ), sort: true },
      { field: 'tasaSeguto', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_TASA' ), sort: true },
    ];


    this.route.params.subscribe( ( params: Params ) => {
      /** Se carga paquete seguro seguro */

      forkJoin( this.serPaqSeguros.listadoPorPaquete( params[ 'id' ]),
        this.serPaqSegPlan.listadoPorPaquete(params[ 'id' ]),
        this.pagSeguroervicio.obtenerPorId( params[ 'id' ] )).subscribe( ( [ seguro, planesSeguros,paquete ] ) => {

        this.paqSeguro = paquete;

        seguro.map( ( s: PaqueteSegurosSeguros ) => {
          this.paqSegSeg = {} as PaqueteSegurosSeguros;
          this.paqSegSeg.idPaqueteSeguroSeguro = s.idPaqueteSeguroSeguro;
          this.paqSegSeg.idPaqueteSeguro = s.idPaqueteSeguro;
          this.paqSegSeg.idSeguro = s.idSeguro;
          this.paqSegSeg.nombreSeguro = s.nombreSeguro;
          this.paqSegSeg.indicadorHabilitado = s.indicadorHabilitado;
          if ( s.valorTasa > 0 ) {
            this.paqSegSeg.valorTasa = s.valorTasa;
            this.paqSegSeg.indicadorSimuladorCredito = s.indicadorSimuladorCredito;
            this.listaPaqSegSeg.push( this.paqSegSeg );
          } else {
            planesSeguros.map( ( pl: PaqueteSegurosSegurosPlanes ) => {
              if( pl.idPaqueteSeguroSeguro === s.idPaqueteSeguroSeguro){
                const paqSegSegTemp = {} as PaqueteSegurosSeguros;
                paqSegSegTemp.idPaqueteSeguroSeguro = s.idPaqueteSeguroSeguro;
                paqSegSegTemp.idPaqueteSeguro = s.idPaqueteSeguro;
                paqSegSegTemp.idSeguro = s.idSeguro;
                paqSegSegTemp.nombreSeguro = s.nombreSeguro;
                paqSegSegTemp.indicadorHabilitado = pl.indicadorHabilitado;
                paqSegSegTemp.idPaqueteSeguroSeguroPlan = pl.idPaqueteSeguroSeguroPlan;
                paqSegSegTemp.idSeguroPlan = pl.idSeguroPlan;
                paqSegSegTemp.planSeguro = pl.nombrePlan;
                paqSegSegTemp.valorPlan = pl.valorPlan;
                paqSegSegTemp.indicadorHabilitadoPlan = pl.indicadorHabilitado;
                paqSegSegTemp.indicadorSimuladorCredito = pl.indicadorSimuladorCredito;
                this.listaPaqSegSeg.push( paqSegSegTemp );
              }
            } );
          }
        } );
        this.carInformacionInicial = false;
      } );
    } );

  }

  get paqSegurosSeguros() {
    return this.listaPaqSegSeg.filter( s => s.indicadorHabilitado );
  }

  regresar() {
    this.location.back();
  }
}
